import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { GetItemsParams } from '../../attorney/service/attorney.model';
import { Observable } from 'rxjs';
import { Page } from 'src/app/enums/enums';
import { WeekDays } from '../../patient-checklist/services/patient-checklist.service';

@Injectable({
  providedIn: 'root'
})
export class TransportationChecklistService {
  constructor(private apiService: HttpService) {}

  GetTransportationCheckList(param: GetItemsParams): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('searchDate', param.searchDate || Date());
    params = params.set('clinicId', param.clinicId || 0);
    params = params.set('searchValue', param.searchValue);
    params = params.set('pageNumber', param.pageNumber || 1);
    params = params.set('pageSize', param.pageSize || Page.Size);
    return this.apiService.getData(`Report/GetTransportationCallingSchedule`, params);
  }

  UpdateTransportationAttendance(id: number, data: WeekDays): Observable<any> {
    return this.apiService.putData(`Report/TransportationCallingSchedule/${id}`, data);
  }
  /*   ExportTransportationAttendance(param: GetItemsParams): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('searchDate', param.searchDate || Date());
    params = params.set('clinicId', param.clinicId || 0);
    params = params.set('searchValue', param.searchValue);
    return this.apiService.getData(`Report/ExportPatientCallingSchedule`, params);
  } */
}
